<template>
  <div class="new-scene">
    <el-form :model="sceneData" ref="sceneData" label-width="200px" class="new-scene-form">
      
      <el-form-item label="Name" prop="name">
        <el-input v-model="sceneData.name"></el-input>
      </el-form-item>
      
      <el-form-item label="Type" prop="type_id" style="text-align: left">
        <el-select v-model="sceneData.type_id">
          <el-option
            v-for="type in types"
            :key="type.id"
            :label="type.name"
            :value="type.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Light Percentage" prop="percentage">
        <el-slider v-model="sceneData.percentage" 
          show-input>
        </el-slider>
      </el-form-item>
      
      <el-form-item label="Light Consumption (kW)" prop="consumption">
        <el-slider v-model="sceneData.consumption" 
          :max="200"
          :step="0.1"
          show-input>
        </el-slider>
      </el-form-item>
      
      <el-form-item label="Device" prop="power_relay" style="align: left;" required>
        <el-select v-model="sceneData.power_relay" placeholder="Device">
          <el-option 
              v-for="device in devices"
              :key="device.id"
              :label="device.name"
              :value="device.id">
          </el-option>
        </el-select>
      </el-form-item>

      <div v-if="getDeviceType(sceneData.power_relay) !== 4">

        <el-form-item label="Logical" style="align: left;" required>
          <el-select v-model="sceneData.logical_no" placeholder="Logical no" :disabled="sceneData.power_relay <= 0">
            <el-option
              v-for="logical in logicals"
              :key="logical.logical_no"
              :label="logical.logical_no"
              :value="logical.logical_no">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Function" style="align: left;" required>
          <el-select v-model="sceneData.function_id" placeholder="Function">
            <el-option
              v-for="f in functions"
              :key="f.id"
              :label="f.name"
              :value="f.id">
            </el-option>
          </el-select>
        </el-form-item>

      </div>

      <div v-else>

        <el-form-item label="Group" style="align: left;" required>
          <el-select v-model="sceneData.logical_no" placeholder="Group no" :disabled="sceneData.power_relay <= 0">
            <el-option
              v-for="group in groups"
              :key="group.id || group.groupid"
              :label="group.name"
              :value="group.id || group.groupid">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Scene" style="align: left;" required>
          <el-select v-model="sceneData.function_id" placeholder="CB Scene">
            <el-option
              v-for="scene in cbScenes"
              :key="scene.id"
              :label="scene.name"
              :value="scene.id">
            </el-option>
          </el-select>
        </el-form-item>

      </div>


        <el-form-item>
          <el-button type="save" @click="submit('sceneData')">Create</el-button>
          <el-button type="cancel" @click="close">Cancel</el-button>
        </el-form-item>



    </el-form>
  </div>
</template>

<script>
import auth from '../../../auth';
import requests from '../../../requests';

export default {
  name: 'admin-new-scene',
  props:['fieldId'],
  data () {
    return {
      pageName: 'New Scene',
      sceneData: {
        name: '',
        percentage: 0,
        consumption: 0,
        type_id:'',
        logical_no:'',
        power_relay:'',
        function_id:''
      },
      userIsSuperAdmin: false,
      types: [],
      devices:[],
      logicals:[],
      functions:[],
      groups: [],
      cbScenes: [],
      defaultGroups: [
        { id: 1, name: '4 (S)' },
        { id: 2, name: '5 (N)' }
      ],
      defaultCbScenes: [
        { id: 1, name: 'North Full' },
        { id: 2, name: 'South Full' },
        { id: 3, name: '50%' },
        { id: 4, name: '75%' },
        { id: 5, name: 'On' },
        { id: 6, name: 'Off' },
      ]
    }
  },
  methods: {
    newScene(){
      var sceneData = this.sceneData;

      sceneData.field_id = parseInt(this.fieldId);
      sceneData.device_type = this.getDeviceType(sceneData.power_relay);

      var context = this;

      console.log(sceneData)

      requests.newScene(this, sceneData, function (result) {
        if(result.action === 'success'){
          context.$message({
            showClose: true,
            type: 'success',
            message: 'Successfully created scene ' + sceneData.name
          });

          context.close();

        } else {

          context.$message({
            type: 'error',
            message: 'Failed to create new scene: ' + result.msg,
          });
        }
      });

    },
    submit(formName) {
      // console.log(this.userData);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.newScene();
          //this.reset(formName);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    reset(formName) {
      this.$refs[formName].resetFields();
    },
    close() {
      this.reset('sceneData');
      this.$emit('close');
    },
    getDeviceType(id) {
      if(!id) return 0
      return this.devices.filter(v => v.id === id)[0].type_id
    }
  },
  beforeMount() {
    var context = this;
    var profile = JSON.parse(auth.getProfile());
    this.userIsSuperAdmin = (profile.role === 3);
    
    requests.getDevices(this, function(result){
      context.devices = result.data;
    });
    
    requests.getSceneTypes(this, function(result){
      context.types = result.data;
    });
    
    requests.getRelayFunctions(this, function(result){
      context.functions = result.data;
    });
  },
  watch: {
    'sceneData.power_relay':function(val){
      if(!val || val < 1){
        return false;
      }

      var context = this;

      if (this.getDeviceType(val) !== 4) {
        requests.getDeviceRelays(this, val, function(result){
          context.logicals = result.data;
        });
      } else {
        const selectedDevice = this.devices.find(device => device.id === val)

        requests.getControlBoxGroups(this, `${selectedDevice.ip}:${selectedDevice.port}`, function(result) {
          console.log(result)
          if (result && result.status === 200) {
            context.groups = result.data.groups
          } else if (result && result.errno) {
            context.$message({
              type: 'error',
              message: `Groups: Error from ${result.address}: ${result.errno}, ${result.code}`,
              duration: 2000
            })
            context.cbScenes = []
          } else {
            context.groups = context.defaultGroups
          }
        })
      }
    },
    'sceneData.logical_no': function (groupId) {
      // If not a control box, return
      if (this.getDeviceType(this.sceneData.power_relay) !== 4) {
        return
      }

      var context = this;
      const selectedDevice = this.devices.find(device => device.id === this.sceneData.power_relay)

      requests.getControlBoxScenes(this, `${selectedDevice.ip}:${selectedDevice.port}`, groupId, function (result) {
          console.log(result)
          if (result && result.status === 200) {
            context.cbScenes = result.data
          } else if (result && result.errno) {
            context.$message({
              type: 'error',
              message: `Scenes: Error from ${result.address}: ${result.errno}, ${result.code}`,
              duration: 2000
            })
            context.cbScenes = []
          } else {
            context.cbScenes = context.defaultCbScenes
          }
      })
    }
  }
}
</script>

<style>
  .admin-new-scene {
    display: none;
  }
  
  .show {
    display: block !important;
  }

</style>



// WEBPACK FOOTER //
// NewScene.vue?50b5b3f8